// Yizhou footer colophon (DR-2026-248 slot pattern; guides/ekonomi precedent).
// Replaces VLT's default Colophon, whose "Powered by Plone" text misstates
// the fleet's stack (the backend is Nick — operator, s527). Brand line +
// operator-worded powered-by ("Powered by Nick and Volto VLT", s527); the AR
// identity line (REF-YIZHOU-001 Part D §5.1) is gated on the open AR-entity
// question + the steven review round, and the company's Chinese name is
// reviewer-owned (brands stay Latin until then).
import logoSrc from '../assets/yizhou-logo.png';

const YizhouColophon = () => (
  <div className="yizhou-colophon">
    <img src={logoSrc} alt="YiZhou Laser" height="72" />
    <p>
      <strong>YiZhou Laser</strong>
      <span className="colophon-meta">Powered by Nick and Volto VLT</span>
    </p>
  </div>
);

export default YizhouColophon;
